import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsArticlesRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsArticlesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { helpCenterSettingArticlesAppPageEntryPoint } from './ui/articles/index.tsx';

export const helpCenterSettingsArticlesRouteEntry: Route = createEntry(
	helpCenterSettingsArticlesRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.articles',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint: () => helpCenterSettingArticlesAppPageEntryPoint,
		resources: [...getServiceDeskSettingsResources(), customerExperiencesNavigationResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
